module.exports = "/_next/static/images/3eb3f5d8c036ea302c3edce0e2c1e021-cajita-lg.png";